import React from 'react';

// common spinner object for our Loader component.  DRY principle :D
var spinner = /*#__PURE__*/React.createElement("div", {
  className: "cssload-double-torus"
}, /*#__PURE__*/React.createElement("div", {
  className: "cssload-double-torus-arrow"
}));

// a react compatible version (pure function)
var spinnerJSX = function spinnerJSX() {
  return spinner;
};
var loaderOpacity = 3;
var loaderOpacityLight = 1.5;
var loaderBackgroundStyle = {
  backgroundColor: 'unset'
};
export { spinner, spinnerJSX, loaderOpacity, loaderOpacityLight, loaderBackgroundStyle };